<script>
import {mapState} from 'vuex'

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    data() {
        return {
            step: 1,
            form: this.mindsetAssessment,
            disableOnSubmit : false,
            dictionary: {
                en: {
                    attributes: {
                        i_feel_close_to_achieving_my_purpose : 'i feel close to achieving my purpose ',
                        i_feel_close_to_achieving_my_vision : 'i feel close to achieving my vision ',
                        i_can_readily_name_my_core_values : 'i can readily name my core values ',
                        i_know_who_i_am : 'i know who i am ',
                        i_am_self_aware : 'i am self aware ',
                        i_am_self_knowledgeable : 'i am self knowledgeable ',
                        i_feel_content : 'i feel content ',
                        i_feel_well_physically : 'i feel well physically ',
                        i_feel_well_mentally : 'i feel well mentally ',
                        i_am_resilient : 'i am resilient ',
                        i_am_responsible: 'i am responsible',
                        i_am_a_good_communicator: 'i am a good communicator',
                        i_demonstrate_humanity: 'i demonstrate humanity',
                        i_have_a_broad_sense_of_perspective: 'i have a broad sense of perspective',
                        i_am_committed_to_my_personal_progress: 'i am committed to my personal progress',
                    }
                },
            }
        }
    },

    props: ['showModal', 'url', 'mindsetAssessment'],

    mixins: [validateAndSubmit, validationClass],

    computed: {
    },

    created() {
    },

    mounted() {
        Object.entries(this.form).forEach(([key, value]) => {
            if (value == null) {
                this.form[key] = 0;
            }
        });

        if(this.showModal) {
            setTimeout(function () {
                $('#mindsetAssessmentFormModal').modal('show');
            }, 500);
        }
        this.$validator.localize(this.dictionary);
    },

    watch: {
    },

    methods: {
        nextStep() {
            this.step +=1;
        },
        previousStep() {
            if (this.step > 1) {
                this.step -=1;
            }
        },
    },

    components: {
        VueSlider
    }
}
</script>
